import { render } from "./AddClientModal.vue?vue&type=template&id=5b4ec94a&scoped=true"
import script from "./AddClientModal.vue?vue&type=script&lang=js"
export * from "./AddClientModal.vue?vue&type=script&lang=js"

import "./AddClientModal.vue?vue&type=style&index=0&id=5b4ec94a&lang=stylus&scoped=true"
import "./AddClientModal.vue?vue&type=style&index=1&id=5b4ec94a&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4ec94a"]])

export default __exports__